import styled, { css } from 'styled-components'
import { ReactComponent as MaskIcon } from '@sketch/icons/arrow-left-down-17'

export const ElementIconContainer = styled.div<{
  $isComponent?: boolean
  $isSelected?: boolean
}>(
  ({ theme, $isComponent, $isSelected }) => css`
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;

    ${$isSelected
      ? css`
          color: ${theme._name === 'dark'
            ? theme.colors.foreground.secondary.A
            : theme.colors.foreground.primary.A};
        `
      : css`
          color: ${$isComponent
            ? theme.colors.inspect.component.A
            : theme.colors.foreground.secondary.D};
        `}
  `
)

export const StyledMaskedIcon = styled(MaskIcon)`
  width: 17px;
  height: 17px;
  margin-top: 1px; /* stylelint-disable-line scales/space */
`
